"use strict";
var zip_1 = require('../operators/zip');
exports.zip = zip_1.zipStatic;
//# sourceMappingURL=zip.js.map


//////////////////
// WEBPACK FOOTER
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/~/rxjs/observable/zip.js
// module id = ../../../../rxjs/observable/zip.js
// module chunks = 3